<tt-page>
    <tt-page-heading [ttModel]="'p2_m_edgerelations'" ttTranslate></tt-page-heading>
    <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>
